import React, { useState, useEffect, useRef } from 'react';

const stats = [
  { value: 15000, suffix: '+', label: 'Meals Served' },
  { value: 4.9, suffix: '★', label: 'Google Rating', isDecimal: true },
  { value: 420, suffix: '+', label: 'Google Reviews' },
  { value: 98, suffix: '%', label: 'Satisfaction Rate' },
  { value: 6, suffix: '+', label: 'Years Experience' },
];

const StatsCounter = () => {
  const [counted, setCounted] = useState(stats.map(() => 0));
  const [hasAnimated, setHasAnimated] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !hasAnimated) {
          if (prefersReduced) {
            setCounted(stats.map(s => s.isDecimal ? s.value : s.value));
          } else {
            animateCounters();
          }
          setHasAnimated(true);
        }
      },
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, [hasAnimated]);

  const animateCounters = () => {
    const duration = 2000;
    const steps = 60;
    const interval = duration / steps;
    let step = 0;
    const timer = setInterval(() => {
      step++;
      const progress = step / steps;
      setCounted(stats.map(s => s.isDecimal ? parseFloat((s.value * progress).toFixed(1)) : Math.floor(s.value * progress)));
      if (step >= steps) {
        clearInterval(timer);
        setCounted(stats.map(s => s.value));
      }
    }, interval);
  };

  return (
    <section className="stats-section" ref={sectionRef}>
      <div className="container">
        <div className="row">
          {stats.map((stat, i) => (
            <div key={i} className="col-6 col-md stat-card">
              <div className="stat-number">
                {stat.isDecimal ? counted[i] : counted[i].toLocaleString()}{stat.suffix}
              </div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsCounter;
